import React, { FunctionComponent } from "react";
import { Rate } from "antd";
import { V2Question } from "../../helper";
import styles from "../TabularForm.module.scss";

interface StarRatingLargeProps {
  question: V2Question;
  value: number | null;
  onChange: (value: number) => void;
  disabled?: boolean;
}

// Larger star rating for the grid; count from validation.maxRating (default 5), size via CSS.
const StarRatingLarge: FunctionComponent<StarRatingLargeProps> = ({ question, value, onChange, disabled }) => {
  const count = Number(question.validation?.maxRating) || 5;
  const current = typeof value === "number" ? value : 0;
  return (
    <div className={styles.starRating}>
      <Rate allowHalf count={count} value={current} onChange={onChange} disabled={disabled} />
      {current > 0 && (
        <span className={styles.ratingValue}>
          {current}/{count}
        </span>
      )}
    </div>
  );
};

export default StarRatingLarge;
